import { Grid } from "@mui/material";
import { FC } from "react";

import { CollapsibleCard } from "@/components/elements/CollapsibleCard";
import { EMPTY_STR } from "@/constants/string";
import { ResultField } from "@/modules/irohana-components/elements/ResultField";
import {
  getBillingCycleLabel,
  getInvoiceDisplayFormatLabel,
} from "@/features/organization/product/constants/productEnums";
import { TProductDetail } from "@/api/services/main/organization/product/dtos/product.dto";
import { formatMonths, formatYen, showsFirstDiscount } from "@/features/organization/product/utils/productUtils";
import { useProductMasters } from "@/features/organization/product/hooks/useProductMasters";

type TProductBasicInfoViewProps = {
  product: TProductDetail;
};

/** 商品基本情報 — read-only grid inside a collapsible card (商品詳細). */
export const ProductBasicInfoView: FC<TProductBasicInfoViewProps> = ({ product }) => {
  const { getTaxRateDisplayName } = useProductMasters();
  const showFirstDiscount = showsFirstDiscount(product.name);

  return (
    <CollapsibleCard title="商品基本情報">
      <Grid container columnSpacing={3} rowSpacing={2}>
        <Grid item xs={12} md={6}>
          <ResultField label="商品名" value={product.name || EMPTY_STR.TEXT} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultField label="科目区分" value={product.accountCategory || EMPTY_STR.TEXT} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultField label="単位" value={product.unit || EMPTY_STR.TEXT} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultField label="単価（税抜）" value={formatYen(product.unitPrice)} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultField label="値引き（特定2号）" value={formatYen(product.discountTokutei2)} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultField label="税区分" value={getTaxRateDisplayName(product.taxRateId) || EMPTY_STR.TEXT} />
        </Grid>

        {showFirstDiscount && (
          <>
            <Grid item xs={12} md={6}>
              <ResultField label="初回割引期間" value={formatMonths(product.firstDiscountPeriod)} />
            </Grid>
            <Grid item xs={12} md={6}>
              <ResultField label="初回割引単価" value={formatYen(product.firstDiscountPrice)} />
            </Grid>
          </>
        )}

        <Grid item xs={12} md={6}>
          <ResultField label="請求サイクル" value={getBillingCycleLabel(product.billingCycle) || EMPTY_STR.TEXT} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultField label="請求書上の表示形式" value={getInvoiceDisplayFormatLabel(product.invoiceDisplayFormat) || EMPTY_STR.TEXT} />
        </Grid>
        <Grid item xs={12}>
          <ResultField label="商品設定" value={product.isActive ? "有効" : "無効"} />
        </Grid>
        <Grid item xs={12}>
          <ResultField label="メモ" value={product.description || EMPTY_STR.TEXT} valueSx={{ whiteSpace: "pre-wrap" }} />
        </Grid>
      </Grid>
    </CollapsibleCard>
  );
};
